
export class StatusDetailsModel {
  StatusId : number;
  StatusValue :string;
}
